/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewintro2Inputs */

const en_letterpreviewintro2 = /** @type {(inputs: Letterpreviewintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The letter is sent in Portuguese — the language your contractor speaks. Read the English version first to confirm it's right, then download the Portuguese PDF to send.`)
};

const pt_letterpreviewintro2 = /** @type {(inputs: Letterpreviewintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carta é enviada em português — a língua do empreiteiro. A tradução inglesa serve apenas para sua referência. Descarregue o PDF em português para enviar.`)
};

/**
* | output |
* | --- |
* | "The letter is sent in Portuguese — the language your contractor speaks. Read the English version first to confirm it's right, then download the Portuguese PD..." |
*
* @param {Letterpreviewintro2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewintro2 = /** @type {((inputs?: Letterpreviewintro2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewintro2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewintro2(inputs)
	return pt_letterpreviewintro2(inputs)
});
export { letterpreviewintro2 as "letterPreviewIntro" }